import { createContext } from "react";
import { emptyRenter, IRenter } from "../../../../types/renter.type";

type InitialStateType = {
  renter: IRenter
  saveRenter: (renterData: IRenter) => Promise<{
    ok: boolean;
    data: IRenter;
    errors: Array<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      message: string | any;
      path: string[] | never[];
    }>;
  }>;
};

export const initialState: InitialStateType = {
  renter: emptyRenter(),
  saveRenter: () => Promise.reject({
    ok: false,
    data: emptyRenter(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}
export const RenterDashboardContext = createContext(initialState)